<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">운행 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.driverUsageHeader1"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{props.item.id}}</td>
                  <td class="text-sm-center">{{props.item.callOption}}</td>
                  <td class="text-sm-center">{{props.item.payMethod}}</td>
                  <td class="text-sm-center">{{props.item.state}}</td>
                  <td class="text-sm-center">{{props.item.startLocationName}}</td>
                  <td class="text-sm-center">{{props.item.endLocationName}}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-divider></v-divider>

            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.driverUsageHeader2"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{props.item.taxiFee}} 원</td>
                  <td class="text-sm-center">{{props.item.extraFee}} 원</td>
                  <td class="text-sm-center">{{props.item.serviceFee}} 원</td>
                  <td class="text-sm-center">{{props.item.totalFee + props.item.serviceFee}} 원</td>
                </template>
              </v-data-table>
            </v-list>

            <template v-if="driverUsage.callHistory">
              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.basicHeader2"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">{{props.item.callAcceptTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.startTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.endTimestamp}}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>

            <template v-if="driverUsage.matchingHistory">
              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.banbanHeader1"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">{{props.item.callAcceptTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.startTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.secondBoardedTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.firstDestTimestamp}}</td>
                    <td class="text-sm-center">{{props.item.endTimestamp}}</td>
                  </template>
                </v-data-table>
              </v-list>

              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.banbanHeader2"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">{{props.item.matchingHistory.pickupUserId1}} -> {{props.item.matchingHistory.pickupUserId2}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId1}} -> {{props.item.matchingHistory.dropOffUserId2}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory1.startLocationName}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory2.startLocationName}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId1 == props.item.matchingHistory.callHistory1.passengerId ? props.item.matchingHistory.callHistory1.endLocationName : props.item.matchingHistory.callHistory2.endLocationName}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId2 == props.item.matchingHistory.callHistory1.passengerId ? props.item.matchingHistory.callHistory1.endLocationName : props.item.matchingHistory.callHistory2.endLocationName}}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>

            <template v-if="driverUsage.driverUsageCancelHistory">
              <v-toolbar dark color="primary" flat dense cad>
                <v-toolbar-title class="subheading">취소 내역</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.driverUsageCancelHistoryHeader"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">{{ changeRunningStateText(props.item.driverUsageCancelHistory.driverStatus) }}</td>
                    <td class="text-sm-center">{{ props.item.driverUsageCancelHistory.requestUserType == 'P' ? '승객' : '기사' }}</td>
                    <td class="text-sm-center">{{ changeCallCancelReasonText(props.item.driverUsageCancelHistory.reason) }}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>

            <v-toolbar dark color="primary" flat dense cad>
              <v-toolbar-title class="subheading">기사 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.driverHeader"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">
                    <router-link :to="{ name: 'components/driverMemberDetail', params: {id: props.item.driverId}}" target="_blank">{{ props.item.driverId }}</router-link>
                  </td>
                  <td class="text-sm-center">{{ props.item.driver.personalInfo.name }}</td>
                  <td class="text-sm-center">{{ props.item.driver.phoneNumber }}</td>
                  <td class="text-sm-center">{{ props.item.carNum }}</td>
                  <td class="text-sm-center">{{ props.item.carModelName }}</td>
                </template>
              </v-data-table>
            </v-list>

            <template v-if="driverUsage.callHistory">
              <v-toolbar dark color="primary" flat dense cad>
                <v-toolbar-title class="subheading">승객 정보</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.passengerHeader"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">
                      <template v-if="props.item.callHistory.passenger.id > 0">
                        <router-link :to="{ name: 'components/passengerMemberDetail', params: {id: props.item.callHistory.passenger.id}}" target="_blank">
                          {{ props.item.callHistory.passenger.id }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ props.item.callHistory.passenger.id }}
                      </template>
                    </td>
                    <td class="text-sm-center">{{ props.item.callHistory.passenger.name }}</td>
                    <td class="text-sm-center">{{ props.item.callHistory.passenger.phoneNumber }}</td>
                    <td class="text-sm-center">{{changeGenderText(props.item.callHistory.passenger.gender)}}</td>
                    <td class="text-sm-center">{{ props.item.callHistory.startLocationName }}</td>
                    <td class="text-sm-center">{{ props.item.callHistory.endLocationName }}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>

            <template v-if="driverUsage.matchingHistory">
              <v-toolbar dark color="primary" flat dense cad>
                <v-toolbar-title class="subheading">승객1 정보</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.passengerHeader"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">
                      <template v-if="props.item.matchingHistory.callHistory1.passenger.id > 0">
                        <router-link :to="{ name: 'components/passengerMemberDetail', params: {id: props.item.matchingHistory.callHistory1.passenger.id}}" target="_blank">
                          {{ props.item.matchingHistory.callHistory1.passenger.id }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ props.item.matchingHistory.callHistory1.passenger.id }}
                      </template>
                    </td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.passenger.name }}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.passenger.phoneNumber }}</td>
                    <td class="text-sm-center">{{changeGenderText(props.item.matchingHistory.callHistory1.passenger.gender)}}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.startLocationName }}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory1.endLocationName }}</td>
                  </template>
                </v-data-table>
              </v-list>

              <v-toolbar dark color="primary" flat dense cad>
                <v-toolbar-title class="subheading">승객2 정보</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.passengerHeader"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">
                      <template v-if="props.item.matchingHistory.callHistory2.passenger.id > 0">
                        <router-link :to="{ name: 'components/passengerMemberDetail', params: {id: props.item.matchingHistory.callHistory2.passenger.id}}" target="_blank">
                          {{ props.item.matchingHistory.callHistory2.passenger.id }}
                        </router-link>
                      </template>
                      <template v-else>
                        {{ props.item.matchingHistory.callHistory2.passenger.id }}
                      </template>
                    </td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.passenger.name }}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.passenger.phoneNumber }}</td>
                    <td class="text-sm-center">{{changeGenderText(props.item.matchingHistory.callHistory2.passenger.gender)}}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.startLocationName }}</td>
                    <td class="text-sm-center">{{ props.item.matchingHistory.callHistory2.endLocationName }}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import CallCancelReason  from '@/api/callCancelReason';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      callCancelReason: CallCancelReason,
      driverUsage: {},
      complex: {
        driverUsageHeader1: [
          {
            text: '운행 고유번호',
            align: 'center',
            sortable: false
          },
          {
            text: '콜 종류',
            align: 'center',
            sortable: false
          },
          {
            text: '결제 수단',
            align: 'center',
            sortable: false
          },
          {
            text: '상태',
            align: 'center',
            sortable: false
          },
          {
            text: '출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '도착지',
            align: 'center',
            sortable: false
          },
        ],
        driverUsageHeader2: [
          {
            text: '미터기 요금',
            align: 'center',
            sortable: false
          },
          {
            text: '추가 요금(통행료)',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 수익',
            align: 'center',
            sortable: false
          },
          {
            text: '최종 요금 (미터기 요금 + 추가 요금 + 기사 수익)',
            align: 'center',
            sortable: false
          }
        ],
        basicHeader2: [
          {
            text: '콜 수락 시간',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 탑승 시간',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 하차 시간',
            align: 'center',
            sortable: false
          }
        ],
        banbanHeader1: [
          {
            text: '콜 수락 시간',
            value: 'callAcceptTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 승객 탑승 시간',
            value: 'startTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '두 번째 승객 탑승 시간',
            value: 'secondBoardedTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 승객 하차 시간',
            value: 'firstDestTimestamp',
            align: 'center',
            sortable: false
          },
          {
            text: '두 번째 승객 하차 시간',
            value: 'firstDestTimestamp',
            align: 'center',
            sortable: false
          }
        ],
        banbanHeader2: [
          {
            text: '승차 순서',
            align: 'center',
            sortable: false
          },
          {
            text: '하차 순서',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '두 번째 출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '첫 번째 도착지',
            align: 'center',
            sortable: false
          },
          {
            text: '두 번째 도착지',
            align: 'center',
            sortable: false
          }
        ],
        driverHeader: [
          {
            text: '기사 고유번호',
            value: 'driverId',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 이름',
            value: 'driver.personalInfo.name',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 전화번호',
            value: 'driver.phoneNumber',
            align: 'center',
            sortable: false
          },
          {
            text: '택시번호',
            value: 'carNum',
            align: 'center',
            sortable: false
          },
          {
            text: '택시모델명',
            value: 'carModelName',
            align: 'center',
            sortable: false
          },
        ],
        passengerHeader: [
          {
            text: '승객 고유번호',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 이름',
            value: 'awaiter.id',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 전화번호',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 성별',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '승객 목적지',
            align: 'center',
            sortable: false
          },
        ],
        driverUsageCancelHistoryHeader: [
          {
            text: '취소 당시 상태',
            align: 'center',
            sortable: false
          },
          {
            text: '취소 요청자 (기사/승객 으로만 구분)',
            align: 'center',
            sortable: false
          },
          {
            text: '취소 사유',
            align: 'center',
            sortable: false
          },
        ],
        items: []
      },
    };
  },
  watch: {
    '$route.params' () {
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const parameters = {
        method: 'driverUsageRecordDetail',
        'id': this.$route.params.id
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                console.log(data);

                this.driverUsage = data;
                this.complex.items = [data];

                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    },
    changeGenderText(gender) {
      return top.getApp.changeGenderText(gender);
    },
    changeCallCancelReasonText(reason) {
      return top.getApp.changeCallCancelReasonText(reason);
    },
    changeRunningStateText(state) {
      return top.getApp.changeRunningStateText(state);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/usage/DriverUsageHistoryDetail.vue